(() => {
  const loadRecommendations = (el) => {
    const url = el.dataset.url;
    if (!url || el.dataset.loaded) return;

    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const content = doc.querySelector('[data-product-recommendations]');
        if (content?.innerHTML.trim().length) {
          el.innerHTML = content.innerHTML;
          el.dataset.loaded = 'true';
        } else {
          el.classList.add('hidden');
        }
      })
      .catch(() => el.classList.add('hidden'));
  };

  const observe = (el) => {
    if (el.dataset.loaded) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) {
          loadRecommendations(el);
          observer.disconnect();
        }
      },
      { rootMargin: '200px' }
    );

    observer.observe(el);
  };

  document.querySelectorAll('[data-product-recommendations]').forEach(observe);
})();
